/**
 * Utility functions for API communications.
 */

/**
 * Encodes a JSON payload to bypass strict Web Application Firewalls (WAF).
 * It serializes the object to JSON, encodes URI components, unescapes to UTF-8 bytes,
 * and finally converts to Base64.
 * 
 * @param payload The object to encode
 * @returns A base64 string safe for text/plain transport
 */
export function encodeWafPayload(payload: any): string {
  try {
    return btoa(unescape(encodeURIComponent(JSON.stringify(payload))));
  } catch (error) {
    console.error("Failed to encode WAF payload", error);
    return "";
  }
}
